import axios from 'axios'
import { handleHttpErr } from '../apiHelper'

const state = {
    user: undefined
}

const getters = {
    user: state => state.user,
}

const actions = {
    clearUser({ commit }) {
        commit('updateUser', undefined)
    },
    async updateUser({ commit }) {
        try {
            var res = await axios.get("users")
            res.data.adresse.berechnePublicLocationNeu = false
            commit("updateUser", res.data)
        }
        catch (err) {
            throw handleHttpErr(err)
        }
    },
    async putPublicLocation({ commit, state }, location) {
        try {
            var res = await axios.put("users", {
                adresse: {
                    plz: state.user.adresse.plz,
                    ort: state.user.adresse.ort,
                    berechnePublicLocationNeu: false,
                    location
                }
            })
            commit("updateUser", res.data)
        }
        catch (err) {
            throw handleHttpErr(err)
        }
    },
    async calcAddress({ commit, state }) {
        try {
            var data = {
                adresse: {
                    berechnePublicLocationNeu: true,
                    hausnummer: state.user.adresse.hausnummer,
                    ort: state.user.adresse.ort,
                    plz: state.user.adresse.plz,
                    strasse: state.user.adresse.strasse,
                    wohnortSichtbarkeit: state.user.adresse.wohnortSichtbarkeit
                }
            }
            var res = await axios.put("users", data)
            commit("updateUser", res.data)
        }
        catch (err) {
            throw handleHttpErr(err)
        }
    },
    async putUser({ commit, state }) {
        try {
            var data = {
                handy: state.user.handy,
                email: state.user.email,
                benachrichtigungen: state.user.benachrichtigungen,
                adresse: {
                    berechnePublicLocationNeu: state.user.adresse.berechnePublicLocationNeu,
                    hausnummer: state.user.adresse.hausnummer,
                    ort: state.user.adresse.ort,
                    plz: state.user.adresse.plz,
                    strasse: state.user.adresse.strasse,
                    wohnortSichtbarkeit: state.user.adresse.wohnortSichtbarkeit
                },
                suchStatus: state.user.suchStatus,
            }
            var res = await axios.put("users", data)
            commit("updateUser", res.data)
        }
        catch (err) {
            throw handleHttpErr(err)
        }
    }
}

const mutations = {
    updateUser: (state, user) => state.user = user
}

export default {
    state,
    getters,
    actions,
    mutations
}